import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from 'vue';
import type { FormInstance } from 'element-plus';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'vGroupSearch',
  emits: ['on-search', 'on-reset'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const formRef = ref<FormInstance>();
const form = reactive<{
  name?: string;
}>({
  name: ''
});

const onReset = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
  const cloneForm = { ...form };
  emit('on-reset', cloneForm);
};

const onSubmit = () => {
  const cloneForm = { ...form };
  emit('on-search', cloneForm);
};

return (_ctx: any,_cache: any) => {
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_filter = _resolveComponent("e-filter")!

  return (_openBlock(), _createBlock(_component_e_filter, {
    "show-reset": "",
    "enter-search": "",
    onReset: _cache[2] || (_cache[2] = ($event: any) => (onReset(formRef.value))),
    onSearch: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_e_form, {
        ref_key: "formRef",
        ref: formRef,
        inline: true,
        "label-position": "right",
        model: form,
        "label-width": "60px",
        "show-ellipsis": false,
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_form_item, {
            label: "虚拟组",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                placeholder: "请输入虚拟组名称",
                clearable: "",
                onKeyup: _withKeys(onSubmit, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}
}

})